module.exports = __webpack_public_path__ + "media/images/sp/icon-close-1d27094f96af228479a0ee94427a9beb.png";